import { render, staticRenderFns } from "./TagsManage.vue?vue&type=template&id=3cb8987c&"
import script from "./TagsManage.vue?vue&type=script&lang=js&"
export * from "./TagsManage.vue?vue&type=script&lang=js&"
import style0 from "./TagsManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TagsManage.vue"
export default component.exports